import cn from 'classnames';
import React, { MouseEventHandler, PropsWithChildren } from 'react';
import { CgClose } from 'react-icons/cg';

interface SearchResultRowProps extends PropsWithChildren {
  onRemove?: MouseEventHandler;
  onClick?: MouseEventHandler;
}

export const SearchResultRow = ({
  onRemove,
  onClick,
  children,
}: SearchResultRowProps) => {
  return (
    <div className={'w-full flex items-center justify-between gap-2'}>
      <div
        className={cn(
          'font-extralight cursor-pointer flex-grow text-ellipsis line-clamp-1',
          'hover:text-black hover:font-light',
        )}
        onClick={onClick}
      >
        {children}
      </div>
      {onRemove && (
        <div className={'p-1'} onClick={onRemove}>
          <CgClose className="cursor-pointer w-5 h-5 fill-[#B6B6B6]" />
        </div>
      )}
    </div>
  );
};
